var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fs-14",class:[{'app-page--has-topbar': _vm.hasTopbar},{'swan-compatible':_vm.libPlatform.isBaiduminiapp}],attrs:{"id":"app"}},[(_vm.hasTopbar&&!_vm.libPlatform.isBaiduminiapp)?_c('top-bar',{ref:"topBar"}):_vm._e(),_vm._v(" "),_c('router-view',{staticClass:"app-page__inner"})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-904bdbee","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 